import {
	createStore as reduxCreateStore,
	applyMiddleware,
} from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import { Provider } from 'react-redux';
import config from '../config';
import {
	createSocketIO,
	SocketMiddleware,
} from '../../lib/socket';
import jwt from '../../lib/jwt';
import {
	isInIframe,
} from '../../lib/detect-utils';
import {
	soundMiddleware,
} from '../../lib/sound';
import {
	getLoggerAPIBaseUrl,
	isLoggerEnabled,
} from '../lib/general-utils';
import {
	epics,
	reducer,
	middlewares as reduxMiddlewares,
	socketEmitters,
	socketReceivers,
	soundEmitters,
} from './redux';

const {
	epicMiddleware,
	setPlatformSettingMiddleware,
	notifyHandlerMiddleware,
	jwtMiddleware,
	applicationMiddleware,
	loggerMiddleware,
	clientLoginCodeMiddleware,
	eventLoggerMiddleware,
} = reduxMiddlewares;
const socketUrl =
	(config.MODE === 'local' && !location.hostname.includes('localhost')) ?
		`${location.protocol}//${location.hostname}:3005/` :
		config.CLIENT_SOCKET_URL;
// 被嵌在 iframe 內時,瀏覽器(Safari ITP / Chrome 3rd-party-cookie-block / Firefox TCP)
// 會擋第三方 cookie,sticky-session cookie 丟失導致 polling 跨 pod 400。
// 此情境改走 WebSocket-only(不需 cookie sticky)並在 init 帶 JWT。
// 非 iframe(直接訪問)維持預設行為(polling-first),避免擴大影響面。
const socketIOOptions = isInIframe ?
	{
		transports: ['websocket'],
		query: { token: jwt.current },
	} :
	{};
const initialSocketIO = createSocketIO(
	socketUrl,
	socketIOOptions,
	{
		enable: isLoggerEnabled,
		baseUrl: getLoggerAPIBaseUrl(),
	},
);
const socketMiddleware = new SocketMiddleware(initialSocketIO);

export function createStore(initState = {}) {
	const applyMiddlewareList = [
		epicMiddleware,
		setPlatformSettingMiddleware,
		notifyHandlerMiddleware,
		jwtMiddleware,
		applicationMiddleware,
		clientLoginCodeMiddleware,
		socketMiddleware.redux,
		soundMiddleware.redux,
	];
	let store;

	if (config.MODE === 'production' || config.MODE === 'pre-production') {
		applyMiddlewareList.push(eventLoggerMiddleware);
		store = reduxCreateStore(reducer, initState, applyMiddleware(...applyMiddlewareList));
	} else {
		applyMiddlewareList.push(loggerMiddleware);
		applyMiddlewareList.push(eventLoggerMiddleware); // TODO check env
		store = reduxCreateStore(reducer, initState, composeWithDevTools(applyMiddleware(...applyMiddlewareList)));
	}

	epicMiddleware.run(epics);
	socketMiddleware.runReceivers(socketReceivers, store);
	socketMiddleware.runEmitters(socketEmitters);
	soundMiddleware.runEmitters(soundEmitters, store);

	return store;
}

export const StoreProvider = Provider;
